export const PRICE_ROUNDING_SCALE = 3;
export const SUM_ROUNDING_SCALE = 2;
export const PERSONAL_CODE_LENGTH = 11;

export const APPLICATIONS_PAGE_TITLE = "taotlused";
export const CARDS_PAGE_TITLE = "kaardid";